import { reactMount } from '@/lib/reactMount';
import { useRef } from 'react';

const umbracoMock = {
  AnchorTarget: 'iframe-block',
  Url: 'https://example.com',
  Height: '500px',
  IsFullWidth: true,
  Theme: 'coral-light',
};

const IframeBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco));
  umbraco ||= umbracoMock; // umbracoRef.current
  const theme = umbraco.Theme || 'coral-light';

  return (
    <section
      id={umbraco?.AnchorTarget || null}
      data-theme={theme}
      className="bg-[--theme-bg] text-[--theme-text] px-4 md:px-8 py-16 md:py-32 lg:px-10"
    >
      <div className="mx-auto w-full mt-10 max-w-5xl xl:px-6">
        <iframe
          src={umbraco.Url}
          title={umbraco.AnchorTarget}
          style={{
            height: umbraco.Height,
            width: umbraco.IsFullWidth ? '100%' : 'auto',
          }}
          className="border-none"
          loading="lazy"
        />
      </div>
    </section>
  );
};

reactMount('IframeBlock', IframeBlock);
